import {
    Box, Icon, Select,
    Table,
    Tbody,
    Text,
    Th,
    Thead,
    Tr,
    useColorModeValue
} from "@chakra-ui/react";
import React, {useEffect} from "react";
import {
    getCoreRowModel,
    getFilteredRowModel,
    getSortedRowModel,
    useReactTable,
} from '@tanstack/react-table'
import SearchWallet from "../../Navbars/SearchBar/SearchWallet";
import DashboardTableRow from "../../DashboardTableRow";
import {useInfiniteQuery} from "@tanstack/react-query";
import axios from "axios";
import {useAuthHeader} from "react-auth-kit";
import {FaBalanceScaleRight} from "react-icons/fa";
import { numberToReadableFormat } from '../../../services/utility';


const DashboardWalletsTable = ({ title, columns }) => {

    const textColor = useColorModeValue("gray.700", "white");
    const tableContainerRef = React.useRef(null)
    const [sorting, setSorting] = React.useState([])
    const [globalFilter, setGlobalFilter] = React.useState('')
    const [envType, setEnvType] = React.useState('prod')

    const token = useAuthHeader();


    const { data, isLoading, refetch } =
        useInfiniteQuery(
            ["partners", sorting],
            async () => {
                const wall = await fetchWallets(envType, token());
                const partners = await fetchPartner(token());
                const wallPart = []
                Object.values(wall).forEach(w => {
                    Object.values(partners).forEach(p => {
                        if (w.partner_id === p.partner_id) {
                            w['balance'] = numberToReadableFormat(w.balance / 100, w.currency)
                            w['credit'] = numberToReadableFormat(w.credit / 100, w.currency)
                            wallPart.push({...w, ...p})
                        }
                    })
                })

                wallPart.sort(function (a, b) {

                    let nameA = a.name.toLowerCase(),
                        nameB = b.name.toLowerCase()

                    if (nameA < nameB)
                        return -1;
                    if (nameA > nameB)
                        return 1;
                    return 0;
                })

                return wallPart
            },
            {
                keepPreviousData: true,
                refetchOnWindowFocus: false,
            }
        )

    useEffect(() => {
        refetch()
    },[envType])

    const flatData = React.useMemo(
        () => data?.pages?.flatMap(page => page) ?? [],
        [data]
    )

    const table = useReactTable({
        data: flatData,
        columns,
        state: {
            sorting, globalFilter
        },
        onSortingChange: setSorting,
        onGlobalFilterChange: setGlobalFilter,
        getFilteredRowModel: getFilteredRowModel(),
        getCoreRowModel: getCoreRowModel(),
        getSortedRowModel: getSortedRowModel(),
        enableGlobalFilter: true
    })

    const { rows } = table.getRowModel()

    if (isLoading) {
        return <>Loading...</>
    }

    return (
        <>
            <Box p='6px 0px 22px 0px'>
                <Table variant='striped' color={textColor}>
                    <Thead>
                        <tr>
                            <th align={"left"} width={"200px"}>
                                <Text fontSize='md' color={textColor} fontWeight='bold'>
                                    {title} <Icon
                                    as={FaBalanceScaleRight}
                                    color='teal.300'
                                    style={{
                                        "marginBottom": "-3px",
                                    }}
                                />
                                </Text>
                            </th>
                            <th align={"left"}>
                                {/*Выбрать env */}
                                <Select borderRadius="15px" maxW={"100px"} fontSize='sm'
                                        onChange = {(ev) => setEnvType(ev.target.value)}
                                    >
                                    <option value='prod'>prod</option>
                                    <option value='test'>test</option>
                                    <option value='all'>all</option>
                                </Select>
                            </th>
                            <th align={"left"}>
                                {/*Поиск */}
                                <SearchWallet
                                    initialValue={globalFilter ?? ''}
                                    onChange={e => setGlobalFilter(e)}
                                    debounce={500}
                                />
                            </th>
                        </tr>
                    </Thead>
                </Table>
            </Box>

            <Box overflowX="auto"
                 maxH="800px"
                 ref={tableContainerRef}
            >
                <Table variant='striped' color={textColor}>
                    <Thead>
                        {table.getHeaderGroups().map(headerGroup => (
                            <Tr key={headerGroup.id} color='gray.400'>
                                {headerGroup.headers.map((header, idx) => {
                                    return (
                                        <Th
                                            key={header.id}
                                            color='gray.400'
                                            ps={idx === 0 ? "0px" : null}
                                        >
                                            <div
                                                className={
                                                    header.column.getCanSort()
                                                        ? 'cursor-pointer select-none'
                                                        : undefined
                                                }
                                                onClick={header.column.getToggleSortingHandler()}
                                            >
                                                {header.column.columnDef.header}
                                                {{
                                                    asc: ' 🔼',
                                                    desc: ' 🔽',
                                                }[header.column.getIsSorted()] ?? null}
                                            </div>
                                        </Th>
                                    )
                                })}
                            </Tr>
                        ))}
                    </Thead>
                    <Tbody>
                        {rows.map((row) => {
                            return (
                                <DashboardTableRow
                                    key={row.id}
                                    row={row}
                                />
                            );
                        })}
                    </Tbody>
                </Table>
            </Box>
        </>
    );
};

export default DashboardWalletsTable;

async function fetchWallets(envType, token) {
    const response = await axios.get(`/api/v1/wallet`,
        {headers: {Authorization: token}})
    let res = await response.data
    if (typeof res == "object" && typeof res.data !== "undefined") {
        res = res.data;
    }
    let arr = []
    let resEnv = []

    Object.values(res).forEach(id => {
        arr.push(id)
    })

    if (envType !== 'all') {
        arr.forEach(id => {
            if (envType === id.env) {
                resEnv.push(id)
            }
        })
    } else {resEnv = arr}

    resEnv.sort(function(a, b) {
        let keyA = new Date(a.partner_id),
            keyB = new Date(b.partner_id);
        if (keyA > keyB) return -1;
        if (keyA < keyB) return 1;
        return 0;
    });

    return resEnv
}

async function fetchPartner(token) {
    const response = await axios.get(`/api/v1/profile`,
        {headers: {Authorization: token}})
    const res = await response.data
    const arr = []
    res.forEach(obj => {
        obj['partner_id'] = obj['id'];
        delete obj['id'];
        arr.push(obj)
    })

    return arr
}
